import Seperator from '@components/std-components/Seperator'
import { CentricTypography as Typography } from '@core/component/CentricTypography'
import { EnhancedTotalViewKeyMap } from '@modules/order/constants/keys'
import useOrderContext from '@modules/order/hooks/use-order-context'
import { orderKPIGlobalTopBarStore } from '@modules/order/stores/OrderKPIGlobalTopBarStore'
import formatCurrencyValueByLocale from '@utils/format-currency-value-by-locale'
import formatNumberByLocale from '@utils/format-number-by-locale'
import classNames from 'classnames'
import { useObserver } from 'mobx-react-lite'
import React from 'react'
import * as css from '../../OrderTopbarKPITotals.css'
import { useTranslation } from 'react-i18next'
import { nav } from '@stores'
import { getKPICurrency } from '@modules/order/utils/get-kpi-currency'
import find from 'lodash/find'

const EnhancedOrderTopbarOTBTotals: React.FC<any> = () => {
  return useObserver(function useHook() {
    const {
      uiStore: {
        dataStore: { summary },
        quantityTypeStore: { type }
      }
    } = useOrderContext()
    const { t } = useTranslation()
    const {
      queryParams: { orderType, clientId }
    } = nav
    const orderTopbarData = orderKPIGlobalTopBarStore.enhancedOrderKPIsForGlobalTopBar
    const orderTopbarOTB = find(
      orderKPIGlobalTopBarStore?.enhancedOTBData?.children,
      otb => otb?.id === clientId
    )
    const currency = getKPICurrency(orderType, summary)
    const otbCurreny =
      orderTopbarOTB?.buyerCurrency ?? orderTopbarOTB?.globalCurrency ?? ''
    const otbValue = orderTopbarOTB?.buyerBudgetValue || 0
    const otbQty = orderTopbarOTB?.totalBudgetQuantity || 0
    const actualValue = orderTopbarData?.[EnhancedTotalViewKeyMap[type]?.totalValue] ?? 0
    const actualQty = orderTopbarData?.[EnhancedTotalViewKeyMap[type]?.totalQuantity] ?? 0
    const actualValuePct = otbValue ? (actualValue / otbValue) * 100 : 0
    const actualQtyPct = otbQty ? (actualQty / otbQty) * 100 : 0

    return (
      <div className={css.totalsWrapper}>
        <Seperator
          orientation='vertical'
          seperatorStyle='solid'
          seperatorColor='rgba(192,192,192,1)'
          size='20px'
          seperatorThickness='1px'
          margin='4px 5px'
        />
        <div className={css.qtyWrapper}>
          {/* OTB Value  */}
          <div className={css.topBarLabel}>
            <Typography variant={'subtitle1Grey'}>
              {t('order.orderTopbarOTBTotals.otbValue', 'OTB VALUE')}
            </Typography>
          </div>
          <div className={css.valueContainer}>
            <Typography variant={'h6'}>
              {otbCurreny
                ? formatCurrencyValueByLocale(otbCurreny ?? '', otbValue)
                : formatNumberByLocale(otbValue ?? 0, 0, 2)}
            </Typography>
          </div>
        </div>
        <div className={classNames(css.qtyWrapper, css['inline-value'])}>
          <div className={css.topBarLabel}>
            <Typography variant={'subtitle1Grey'}>
              {t('order.orderTopbarOTBTotals.totalValue', ' TOTAL VALUE (%)')}
            </Typography>
          </div>
          <div className={css.valueContainer}>
            <Typography
              variant={
                otbValue < actualValue
                  ? 'h6Green'
                  : otbValue > actualValue
                  ? 'h6Red'
                  : 'h6'
              }
            >
              {`${formatCurrencyValueByLocale(
                currency ?? '',
                actualValue
              )} (${formatNumberByLocale(actualValuePct, 2)}%)`}
            </Typography>
          </div>
        </div>
        <Seperator
          orientation='vertical'
          seperatorStyle='solid'
          seperatorColor='rgba(192,192,192,1)'
          size='20px'
          seperatorThickness='1px'
          margin='4px 5px'
        />
        <div className={css.qtyWrapper}>
          {/* OTB QTY */}
          <div className={css.topBarLabel}>
            <Typography variant={'subtitle1Grey'}>
              {t('order.orderTopbarOTBTotals.otbQty', 'OTB QTY')}
            </Typography>
          </div>
          <div className={css.valueContainer}>
            <Typography variant='h6'>{formatNumberByLocale(otbQty)}</Typography>
          </div>
        </div>
        <div className={classNames(css.qtyWrapper, css['inline-value'])}>
          <div className={css.topBarLabel}>
            <Typography variant={'subtitle1Grey'}>
              {t('order.orderTopbarOTBTotals.totalQty', 'TOTAL QUANTITY (%)')}
            </Typography>
          </div>
          <div className={css.valueContainer}>
            <Typography
              variant={
                otbQty < actualQty ? 'h6Green' : otbQty > actualQty ? 'h6Red' : 'h6'
              }
            >
              {`${formatNumberByLocale(actualQty)} (${formatNumberByLocale(
                actualQtyPct,
                2
              )}%)`}
            </Typography>
          </div>
        </div>
      </div>
    )
  })
}

export default EnhancedOrderTopbarOTBTotals
